import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { AnimatePresence, motion } from "framer-motion";

import "./App.css";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

import HomePage from "./Components/HomePage";
import ItineraryPage from "./Components/ItineraryPage";
import GalleryPage from "./Components/GalleryPage";
import AboutUsPage from "./Components/AboutUsPage";

import WhatsappButton from "./Components/WhatsappButton";
import ScrollToTop from "./Components/ScrollToTop";

import { useEffect, useState } from "react";

/* ================= PAGE LOADER ================= */

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader"></div>
    </div>
  );
};

/* ================= PAGE TRANSITION ================= */

const PageWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 10,
      }}

      animate={{
        opacity: 1,
        y: 0,
      }}

      exit={{
        opacity: 0,
        y: -10,
      }}

      transition={{
        duration: 0.20,
        ease: "easeInOut",
      }}
    >
      {children}
    </motion.div>
  );
};

/* ================= ANIMATED ROUTES ================= */

const AnimatedRoutes = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && <PageLoader />}

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          
          <Route
            path="/"
            element={
              <PageWrapper>
                <HomePage />
              </PageWrapper>
            }
          />

          <Route
            path="/itinerary/:name"
            element={
              <PageWrapper>
                <ItineraryPage />
              </PageWrapper>
            }
          />

          <Route
            path="/gallery"
            element={
              <PageWrapper>
                <GalleryPage />
              </PageWrapper>
            }
          />

          <Route
            path="/about"
            element={
              <PageWrapper>
                <AboutUsPage />
              </PageWrapper>
            }
          />

        </Routes>
      </AnimatePresence>
    </>
  );
};

/* ================= APP ================= */

function App() {
  return (
    <Router>

      <ScrollToTop />

      <Header />

      <AnimatedRoutes />

      <Footer />

      <WhatsappButton />

    </Router>
  );
}

export default App;